import { Injectable } from '@angular/core';
import { AppState, selectAuthState, selectPermisosState } from '../store/app.states';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { NgxIndexedDB } from 'ngx-indexed-db';
import { defer } from 'q';
import { FuncionesGlobales } from '../utilerias/clases/funcionesGlobales';
import { CoalService } from './coal.service';
import { LogOut, SetAuth } from '../store/actions/auth.actions';
import { EliminaPermisos, AsignaPermisos } from '../store/actions/permisos.actions';
import { AsignarOperacion, EliminaOperacion } from 'app/store/actions/operacion.actions';
import { SeleccionarEmpresa } from 'app/store/actions/utils.action';

import { TokenService } from './token.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class SessionInitializer {
    state = false;
    indexedDB: NgxIndexedDB;
    getState: Observable<any>;
    getStatePermisos: Observable<any>;

    constructor(
        private store: Store<AppState>, 
        private coalService: CoalService, 
        public tokenService: TokenService,
        private authService: AuthService) {
        this.getState = this.store.select(selectAuthState);
        this.getStatePermisos = this.store.select(selectPermisosState);
        this.indexedDB = new NgxIndexedDB(environment.nombreAplicacion, 1);
        this.createOBS();
    }

    private createOBS() {
        this.indexedDB.openDatabase(1, (evt: any) => {
            const objectStore = evt.currentTarget.result.createObjectStore('seguridad', { keyPath: 'Id', autoIncrement: false });
            objectStore.transaction.oncomplete = function () {
                const sec = this.db.transaction('seguridad', 'readwrite').objectStore('seguridad');
            };
        });
    }

    public getStateSession(): any {
        return this.state;
    }

    public setStateLogOut(): any {
        this.store.dispatch(LogOut());
        
        this.store.dispatch(EliminaPermisos());
        this.store.dispatch( new EliminaOperacion());
    }

    async validateLogin(): Promise<boolean> {
        const deferred = defer<boolean>();
        const resp = await this.validateIndexed();
        
        if (resp.autenticado) {
            this.state = await this.generateState(resp.payload);
            deferred.resolve(this.state);
        } else {
            deferred.resolve(false);
        }
        return deferred.promise;
    }

    private async validateIndexed(): Promise<any> {
        const deferred = defer<any>();
        this.indexedDB.openDatabase(1).then(async res => {
            await this.indexedDB.getByKey('seguridad', 1).then(async resultado => {                
                if (resultado && resultado.seguridad) {
                    deferred.resolve({
                        autenticado: true,
                        error: '',
                        payload: resultado
                    });
                } else {
                    deferred.resolve({
                        autenticado: false,
                        error: '',
                        payload: null
                    });
                }
            }).catch(async (reason) => {
                deferred.resolve({
                    autenticado: false,
                    error: JSON.stringify(reason),
                    payload: null
                });
            });
        });
        return deferred.promise;
    }

    private async generateState(resp): Promise<boolean> {
        const deferred = defer<boolean>();
        const empresaSel = localStorage.getItem("empresaSeleccionada");
        const payload = { autenticado: true, error: '', seguridad: { ...resp.seguridad } };
    
        this.store.dispatch(SetAuth(payload));
        this.store.dispatch(AsignaPermisos({
            modulos: FuncionesGlobales.GetRecursividad(payload.seguridad.permissions.modules)
        }));
        this.store.dispatch(new AsignarOperacion(resp.operacion));
    
        if (empresaSel && empresaSel !== 'undefined' && empresaSel !== '') {
            try {
                const empresaSeleccionada = JSON.parse(empresaSel);
                this.store.dispatch(SeleccionarEmpresa({ empresaSeleccionada }));
            } catch (error) {
                console.error("Error al parsear la empresa seleccionada:", error);
            }
        } else {
            console.warn("No hay una empresa seleccionada o el valor es inválido, omitiendo la selección de empresa.");
        }
    
        this.tokenService.setToken(payload.seguridad.user.token);
        deferred.resolve(true);
        return deferred.promise;
    }
    

    // private async generateState(resp): Promise<boolean> {
    //     const deferred = defer<boolean>();
    //     const empresaSel = localStorage.getItem("empresaSeleccionada");
    //     const payload = { autenticado: true, error: '', seguridad: { ...resp.seguridad } };
    
    //     this.store.dispatch(SetAuth(payload));
    //     this.store.dispatch(AsignaPermisos({
    //         modulos: FuncionesGlobales.GetRecursividad(payload.seguridad.permissions.modules)
    //     }));
    //     this.store.dispatch(new AsignarOperacion(resp.operacion));
    
    //     if (empresaSel) {
    //         try {
    //             const empresaSeleccionada = JSON.parse(empresaSel);
    //             this.store.dispatch(SeleccionarEmpresa({ empresaSeleccionada }));
    //         } catch (error) {
    //             console.error("Error al parsear la empresa seleccionada:", error);
    //         }
    //     } else {
    //         console.warn("No hay una empresa seleccionada, omitiendo la selección de empresa.");
    //     }
    
    //     this.tokenService.setToken(payload.seguridad.user.token);
    //     deferred.resolve(true);
    //     return deferred.promise;
    // }
    

    // private async generateState(resp): Promise<boolean> {
    //     const deferred = defer<boolean>();
    //     let empresaSel = localStorage.getItem("empresaSeleccionada");
    //     const payload = { autenticado: true, error: '', seguridad: {...resp.seguridad} };
    //     this.store.dispatch
    //     this.store.dispatch(SetAuth(payload));
    //     this.store.dispatch(AsignaPermisos({
    //         modulos: FuncionesGlobales.GetRecursividad(payload.seguridad.permissions.modules)
    //     }));
    //     this.store.dispatch( new AsignarOperacion( resp.operacion ) );
    //     this.store.dispatch(
    //         SeleccionarEmpresa({ empresaSeleccionada: JSON.parse(empresaSel) })
    //     );
    //     this.tokenService.setToken(payload.seguridad.user.token)
    //     deferred.resolve(true);
    //     return deferred.promise;
    // }
}
